/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'vbY4KKDhX4NpeGXFV2pgoq.png': { uri: '/images/vbY4KKDhX4NpeGXFV2pgoq.png' },
'58xRmk2GhgWrcn2vdfqgBD.png': { uri: '/images/58xRmk2GhgWrcn2vdfqgBD.png' },
'wWpksPQwpfpuhvp79EjrwK.png': { uri: '/images/wWpksPQwpfpuhvp79EjrwK.png' },
'2Mwok4fxgNPtScR8xd3jJp.png': { uri: '/images/2Mwok4fxgNPtScR8xd3jJp.png' },
'cR4jkHtVGVQyNzBrAxAQyX.png': { uri: '/images/cR4jkHtVGVQyNzBrAxAQyX.png' },
'irnzFhX8ZmiG9xQuJ22cD4.png': { uri: '/images/irnzFhX8ZmiG9xQuJ22cD4.png' },
'fg1E8r174dZtnQwnMSLFzX.png': { uri: '/images/fg1E8r174dZtnQwnMSLFzX.png' },
'3e2z8zFyS4ow8F5LQ7CqLk.png': { uri: '/images/3e2z8zFyS4ow8F5LQ7CqLk.png' },
'69n9kxmN7o1mQYhQ5yxq6S.png': { uri: '/images/69n9kxmN7o1mQYhQ5yxq6S.png' },
'532xfYog92wpNSna1GkV7Y.png': { uri: '/images/532xfYog92wpNSna1GkV7Y.png' },
'mnniRSPf1K5rZ3CsGBXK3P.png': { uri: '/images/mnniRSPf1K5rZ3CsGBXK3P.png' },
'8or9ZzXWhAEfhE6FYXzWou.png': { uri: '/images/8or9ZzXWhAEfhE6FYXzWou.png' },
'dEyPxDhMSSSzBXnBUuRVWX.png': { uri: '/images/dEyPxDhMSSSzBXnBUuRVWX.png' },
'1S2twjzwEzWG8cabKfQN3q.png': { uri: '/images/1S2twjzwEzWG8cabKfQN3q.png' },
'tCoKMdFpNuDjyWEZLPXYwS.jpg': { uri: '/images/tCoKMdFpNuDjyWEZLPXYwS.jpg' },
'cguYJZYPR3LhjURpBNJQ3F.png': { uri: '/images/cguYJZYPR3LhjURpBNJQ3F.png' },
'9MD14VoKGLYnppTaYwLvEF.png': { uri: '/images/9MD14VoKGLYnppTaYwLvEF.png' },
'oZvCgF3mQ1d3rWwAAmbmPq.png': { uri: '/images/oZvCgF3mQ1d3rWwAAmbmPq.png' },
'aGhNtZubMovFtCyCXLRwSP.png': { uri: '/images/aGhNtZubMovFtCyCXLRwSP.png' },
'mWZFbp2Lc25GwZJUrtfxpu.png': { uri: '/images/mWZFbp2Lc25GwZJUrtfxpu.png' },
'v8aLNv78cqTJmwR8c1d3hw.png': { uri: '/images/v8aLNv78cqTJmwR8c1d3hw.png' },
'dABXNymA5gxTRxqzRhQLyJ.png': { uri: '/images/dABXNymA5gxTRxqzRhQLyJ.png' },
'pHcr1HCk6AKwtk6PdtY5JZ.png': { uri: '/images/pHcr1HCk6AKwtk6PdtY5JZ.png' },
'nT1v3brAvQsQebfj2y1mFS.png': { uri: '/images/nT1v3brAvQsQebfj2y1mFS.png' },
'8ZcfTDJ9TwvvP9EcdJN3b4.png': { uri: '/images/8ZcfTDJ9TwvvP9EcdJN3b4.png' },
'dgJnkFxv7Kb7xQ9mqA8QxB.png': { uri: '/images/dgJnkFxv7Kb7xQ9mqA8QxB.png' },
'mS7nQiZHAVQ3nfgiWayHkx.png': { uri: '/images/mS7nQiZHAVQ3nfgiWayHkx.png' },
'3kLUgPT4RhR3zr1qnFGhqN.png': { uri: '/images/3kLUgPT4RhR3zr1qnFGhqN.png' },
'hvjZvZER9K1VnFNXDgp7YL.png': { uri: '/images/hvjZvZER9K1VnFNXDgp7YL.png' },
'mVivbox99pxSjqdcXB7M4F.png': { uri: '/images/mVivbox99pxSjqdcXB7M4F.png' },
'617amkrxfEQfJhndGG2rFJ.png': { uri: '/images/617amkrxfEQfJhndGG2rFJ.png' },
'2D7oD8bNmSbwsCgxNS4kWa.png': { uri: '/images/2D7oD8bNmSbwsCgxNS4kWa.png' },
'tqL6idhyTZfjRnDKEX953J.png': { uri: '/images/tqL6idhyTZfjRnDKEX953J.png' },
'gFhQE1aZEn8H9TQC8PzTkm.png': { uri: '/images/gFhQE1aZEn8H9TQC8PzTkm.png' },
'eM5wNPvjmvdLUvZrAFDUvQ.png': { uri: '/images/eM5wNPvjmvdLUvZrAFDUvQ.png' },
'kVdzmM8p6Gd1o3LrjGJqaA.png': { uri: '/images/kVdzmM8p6Gd1o3LrjGJqaA.png' },
'efVLXti552YEXHfjxYjjRC.png': { uri: '/images/efVLXti552YEXHfjxYjjRC.png' },
'8ebA6Df7kjTVVN1Uj7SQei.png': { uri: '/images/8ebA6Df7kjTVVN1Uj7SQei.png' },
've4pChkBsvcvqz1FBU3ZyH.png': { uri: '/images/ve4pChkBsvcvqz1FBU3ZyH.png' },
'mq3qGiEiUkLuuDjtQDpaFU.png': { uri: '/images/mq3qGiEiUkLuuDjtQDpaFU.png' },
'6KrQrUUA5Sa13zr7khcSsq.png': { uri: '/images/6KrQrUUA5Sa13zr7khcSsq.png' },
'rMNyYDH8izCK4B8DTyMdC5.png': { uri: '/images/rMNyYDH8izCK4B8DTyMdC5.png' },
'7gyDZemgEJqHSkdDL2Q3tn.png': { uri: '/images/7gyDZemgEJqHSkdDL2Q3tn.png' },
'3ZpPa5mR7LgtLSFmpd65Vb.png': { uri: '/images/3ZpPa5mR7LgtLSFmpd65Vb.png' },
'bgy8TokcqqwGGwZRtkRfJe.png': { uri: '/images/bgy8TokcqqwGGwZRtkRfJe.png' },
'3NDxyaHbFpbapSRPLwi2V6.png': { uri: '/images/3NDxyaHbFpbapSRPLwi2V6.png' },
'u72rMotgKtHkMZKrN7zozS.png': { uri: '/images/u72rMotgKtHkMZKrN7zozS.png' },
'k6cDvpjkw2rdFyksFpCcx9.png': { uri: '/images/k6cDvpjkw2rdFyksFpCcx9.png' },
'awftTXD2cAPD3QnRTnt5Zm.png': { uri: '/images/awftTXD2cAPD3QnRTnt5Zm.png' },
'ezc8Je49StMcizGd1ZKWtp.png': { uri: '/images/ezc8Je49StMcizGd1ZKWtp.png' },
'hvhZmPwyNXdTaDCSQVV9kw.png': { uri: '/images/hvhZmPwyNXdTaDCSQVV9kw.png' },
'36e66KqAqQyW8sGtZSipNE.png': { uri: '/images/36e66KqAqQyW8sGtZSipNE.png' },
'rwz3N34DJJsc4fNwcV7SoK.png': { uri: '/images/rwz3N34DJJsc4fNwcV7SoK.png' },
'4AQrPx5VXUYeh5gyMBqk6W.png': { uri: '/images/4AQrPx5VXUYeh5gyMBqk6W.png' },
'ih9VNHsRZ2ewRe44gNLELa.png': { uri: '/images/ih9VNHsRZ2ewRe44gNLELa.png' },
'umPN8Wz3nN85c7dycpTrhu.png': { uri: '/images/umPN8Wz3nN85c7dycpTrhu.png' },
'1f6u398uny97k2xJtoHPNm.png': { uri: '/images/1f6u398uny97k2xJtoHPNm.png' },
'3F7BZxe3oxgokMwNchUZCz.png': { uri: '/images/3F7BZxe3oxgokMwNchUZCz.png' },
'v6HtYJ9KbidyWTm2B58TC3.png': { uri: '/images/v6HtYJ9KbidyWTm2B58TC3.png' },
'nQGeZnbr73XGBTMUTPgh4a.png': { uri: '/images/nQGeZnbr73XGBTMUTPgh4a.png' },
'o29e2TKE3g8dDSLt5L4u3R.jpg': { uri: '/images/o29e2TKE3g8dDSLt5L4u3R.jpg' }
}

export default imageStaticSourcesByFileName
